var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "about-menu" }, [
    _c(
      "div",
      { staticClass: "extended-block" },
      [
        _c("h6", [_vm._v("What we do")]),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/about/solutions",
            text: "Solutions",
            caption:
              "Learn about how our solutions can help you reach your business goals in Africa",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/about/solutions")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "extended-block" },
      [
        _c("h6", [_vm._v("Company")]),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/about/team",
            text: "Our team",
            caption:
              "Meet our Pan-African team of operators, investors and advisors",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/about/team")
            },
          },
        }),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/about/careers",
            text: "Careers",
            caption:
              "Asoko is growing fast and has exciting opportunities in multiple locations",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/about/careers")
            },
          },
        }),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/insights/developments",
            text: "Press",
            caption: "The latest launches and news from Asoko",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/insights/developments")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "extended-block" },
      [
        _c("h6", [_vm._v("Get in touch")]),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/about/contact",
            text: "Contacts",
            caption: "Have a question? Contact us",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/about/contact")
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }